<template>
  <v-layout>
    <v-flex offset-md2 md8>
      <v-card>
    <v-card-title>
      <v-list-item-title class="headline mb-1"> Extracción de Dinero</v-list-item-title>
      <v-btn
         v-on:click="redireccion"
        icon class="red--text text--darken-2 accent"
       absolute
                  dark
                  small
                  fab
                  center
                  right
      >
                    <v-icon>add</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex style="overflow-x: auto">
             <table class="table">
              <tr>
                <th></th>
                <th></th>
                <th>Tipo</th>
                <th>Cantidad</th>
              </tr>
            <tbody>
              <tr v-for="extraccion in extracciones">
                <td>
                  <v-btn icon class="red--text text--darken-2" @click="eliminarextraccion(extraccion)">
                    <v-icon>delete</v-icon>
                  </v-btn></td>
                <td>
                  <v-btn icon class="blue--text text--darken-2" @click="editarfactura(extraccion)">
                    <v-icon>edit</v-icon>
                  </v-btn></td>
                <td class="text-xs-center">{{extraccion.tipo_nombre}}</td>
                <td class="text-xs-center">{{extraccion.cantidad}}</td>
              </tr>
            </tbody>
          </table>
          </v-flex>
    </v-card-text>
  </v-card>
    </v-flex>
    <v-flex>
    </v-flex>

  </v-layout>

</template>

<script>
  export default {
    created () {
      this.$store.dispatch('requestextracciones')
    },
    data () {
      return {
      }
    },
    computed: {
      extracciones: function () {
        return this.$store.getters.getextracciones
      }
    },
    methods: {
      redireccion: function () {
        this.$router.push('/extraccionadd')
      },
      eliminarextraccion: function (e) {
        let r = confirm(' esta seguro que desea eliminar ' + e.tipo_nombre)
        if (r === true) {
          this.$store.dispatch('eliminarextraccion', e)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Extraccion.vue?fb8cef7a